export interface UnitOfMeasure {
  id: string;
  code: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface UnitOfMeasureFormData {
  code: string;
  name: string;
  description: string;
  isActive: boolean;
}

// Common unit of measures
export const commonUnitOfMeasures = [
  'Each',
  'Box',
  'Pack',
  'Bottle',
  'Gram',
  'Kilogram',
  'Liter',
  'Milliliter',
  'Meter',
  'Centimeter',
  'Inch',
  'Foot'
];
